import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { combineLatest, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, reduce, toArray } from 'rxjs/operators';
import { EventResource } from 'src/app/interfaces/event-resource';
import { EventService } from 'src/app/services/event.service';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { Configs } from './chart-configs'
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state: boolean;
}
/**
 * The Object used to load GoogleCharts
 */
declare var google: any;
/**
 * @ignore
 */
@Component({
  selector: 'app-partnerreport',
  templateUrl: './partnerreport.component.html',
  styleUrls: ['./partnerreport.component.scss']
})
export class PartnerreportComponent {
  @ViewChild('donutchart_0') donutchart_0: ElementRef;
  @ViewChild('donutchart_1') donutchart_1: ElementRef;
  @ViewChild('donutchart_2') donutchart_2: ElementRef;
  @ViewChild('donutchart_0_flop') donutchart_0_flop: ElementRef;
  @ViewChild('donutchart_1_flop') donutchart_1_flop: ElementRef;
  @ViewChild('donutchart_2_flop') donutchart_2_flop: ElementRef;
  calenderFilterForm: UntypedFormGroup;
  filterTestForm: UntypedFormGroup;
  public allEventsSortedBytotalActiveReservationsCount = [];
  public top1Event: EventResource = null;
  public top2Event: EventResource = null;
  public top3Event: EventResource = null;
  public flop1Event: EventResource = null;
  public flop2Event: EventResource = null;
  public flop3Event: EventResource = null;
  public events: SortOption[] = [];

  finishedLoadingFlopsAndTops: boolean = false;
  notEnoughEvents: boolean = false;
  heighCalender = "1600px;"
  finishedLoadingCalendeData: boolean = false;

  data_donut_1 = [];
  data_donut_2 = [];
  data_donut_3 = [];

  data_donut_1_flop = [];
  data_donut_2_flop = [];
  data_donut_3_flop = [];

  data_donut_types = [];
  data_donut_eventLimits = [];
  data_donut_voucherStrats = [];
  data_radar = [];

  data_attendence = [];
  data_interest = [];

  data_savings = [];
  data_word_cloud = []
  treeData = [];
  data_reservations_line = [];

  filteredOptions = [];
  filteredOptions_2 = [];
  filteredOptions_3 = [];
  optionsAuto = [];
  allActiveEvents = [];

  finishedLoadingComparison: boolean = false;

  config_donut = Configs.config_donut;
  config_donut_types = Configs.config_donut_types;
  options_radar = Configs.options_radar;
  options_line_savings = Configs.options_line_savings;

  differenceIsLessThan61: boolean = false;
  isCalenderChartEmpty: boolean = true;
  config;
  allEvents: boolean = false;
  eventFilter = ['ACTIVE', 'HIDDEN']
  dataTemp = [];

  hasSelectedPartner: boolean = false;
  partners = [];
  Allpartners = [];
  currentPartner: BusinessEntityResource;

  eventCount:number = 0;
  alleventCount:number = 0;

  constructor(
    private eventService: EventService,
    private fb: UntypedFormBuilder
  ) {

    google.charts.load('current', { 'packages': ["calendar, corechart"], 'language': 'de' });

    this.filterTestForm = this.fb.group({
      serachForEvent: ["", [Validators.required]],
      serachForEvent_2: ["", [Validators.required]],
      serachForEvent_3: ["", []],
    })

    this.calenderFilterForm = this.fb.group({
      event: ["", []],
    })

    this.eventService.getPartners().subscribe((partners: PagedResources<BusinessEntityResource>) => {
      this.partners = partners.content;
      this.Allpartners = partners.content;
    })
  }



  ngOnInit() {

  }

  //totalActiveReservationsCount
  drawChart = () => {
    combineLatest([
      this.eventService.getTopThreeEvents(this.eventFilter, null, this.currentPartner.publicId, null).pipe(
        catchError(err => of(err)),
      ),
    ]).pipe(
      map(([allEventsSorted]) => {
        this.allEventsSortedBytotalActiveReservationsCount = allEventsSorted;
        if (allEventsSorted.length == 0) {
          this.notEnoughEvents = true;
        } else {
          if (allEventsSorted.length >= 1) {
            this.top1Event = allEventsSorted[0];
          }
          if (allEventsSorted.length >= 2) {
            this.top2Event = allEventsSorted[1];
          }
          if (allEventsSorted.length >= 3) {
            this.top3Event = allEventsSorted[2];
          }
          if (allEventsSorted.length >= 4) {
            this.flop1Event = allEventsSorted[allEventsSorted.length - 1];
          }
          if (allEventsSorted.length >= 5) {
            this.flop2Event = allEventsSorted[allEventsSorted.length - 2];
          }
          if (allEventsSorted.length >= 6) {
            this.flop3Event = allEventsSorted[allEventsSorted.length - 3];
          }
          if (allEventsSorted.length >= 3) {
            this.filterTestForm.patchValue({
              serachForEvent: allEventsSorted[0].publicId,
              serachForEvent_2: allEventsSorted[1].publicId,
              serachForEvent_3: allEventsSorted[2].publicId,
            });
            this.filterEvents();
          }
          //Set Value for Select-Dropdown
          this.calenderFilterForm.patchValue({
            event: this.top1Event.publicId
          })

          this.drawCalenderChart();
          if (allEventsSorted.length >= 1) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[0]?.publicId).subscribe(value => {
              this.top1Event["attendanceCount"] = value.page.totalElements;
              this.data_donut_1.push(
                {
                  "group": "Teilnahmen",
                  "value": value.page.totalElements
                },
                {
                  "group": "Nicht eingelöst",
                  "value": allEventsSorted[0].totalActiveReservationsCount - value.page.totalElements
                }
              )
              this.data_donut_1 = [...this.data_donut_1];
            })
          }

          if (allEventsSorted.length >= 2) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[1]?.publicId).subscribe(value => {
              this.top2Event["attendanceCount"] = value.page.totalElements;
              this.data_donut_2.push({
                "group": "Teilnahmen",
                "value": value.page.totalElements
              },
                {
                  "group": "Nicht eingelöst",
                  "value": allEventsSorted[1].totalActiveReservationsCount - value.page.totalElements
                })

              this.data_donut_2 = [...this.data_donut_2];
            })
          }
          if (allEventsSorted.length >= 3) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], allEventsSorted[2]?.publicId).subscribe(value => {
              this.top3Event["attendanceCount"] = value.page.totalElements;
              this.data_donut_3.push(
                {
                  "group": "Teilnahmen",
                  "value": value.page.totalElements
                },
                {
                  "group": "Nicht eingelöst",
                  "value": allEventsSorted[2].totalActiveReservationsCount - value.page.totalElements
                })

              this.data_donut_3 = [...this.data_donut_3];
            })
          }

          if (allEventsSorted.length >= 4) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop1Event?.publicId).subscribe(value => {
              this.flop1Event["attendanceCount"] = value.page.totalElements;

              this.data_donut_1_flop.push({
                "group": "Teilnahmen",
                "value": value.page.totalElements
              },
                {
                  "group": "Nicht eingelöst",
                  "value": this.flop1Event.totalActiveReservationsCount - value.page.totalElements
                })

              this.data_donut_1_flop = [...this.data_donut_1_flop];
            });
          }
          if (allEventsSorted.length >= 5) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop2Event?.publicId).subscribe(value => {
              this.flop2Event["attendanceCount"] = value.page.totalElements;
              this.data_donut_2_flop.push(
                {
                  "group": "Teilnahmen",
                  "value": value.page.totalElements
                },
                {
                  "group": "Nicht eingelöst",
                  "value": this.flop2Event.totalActiveReservationsCount - value.page.totalElements
                })
              this.data_donut_2_flop = [...this.data_donut_2_flop];
            });
          }
          if (allEventsSorted.length >= 6) {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], this.flop3Event?.publicId).subscribe(value => {
              this.flop3Event['attendanceCount'] = value.page.totalElements;
              this.data_donut_3_flop.push(
                {
                  "group": "Teilnahmen",
                  "value": value.page.totalElements
                },
                {
                  "group": "Nicht eingelöst",
                  "value": this.flop3Event.totalActiveReservationsCount - value.page.totalElements
                })
              this.data_donut_3_flop = [...this.data_donut_3_flop];
            });
          }
        }
      })
    ).subscribe(() => {
      this.finishedLoadingFlopsAndTops = true;
      this.finishedLoadingComparison = true;
    })
  }

  drawCalenderChart() {
    this.finishedLoadingCalendeData = false;
    document.getElementById('calendar_basic')!.style.display = 'block';
    this.isCalenderChartEmpty = false;
    google.charts.load('current', {
      'packages': ["calendar, corechart"], 'language': 'de', callback: () => {
        var dataTable = new google.visualization.DataTable();
        dataTable.addColumn({ type: 'date', id: 'Date' });
        dataTable.addColumn({ type: 'number', id: 'Reservations' });

        this.eventService.getReservationListForEventGrouped(this.calenderFilterForm.value.event).subscribe((val: Array<any>) => {
          val.forEach(element => {
            this.data_reservations_line.push({
              "group": "Reservierungen",
              "key": new Date(element.day).toLocaleDateString("de-De", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }),
              "value": element.reservationCount.toLocaleString('de-DE')
            })
          });
          this.data_reservations_line = [...this.data_reservations_line];

          //Push Grouped Dates to DataArray
          if (val.length >= 1) {
            val.forEach(element => {
              dataTable.addRows([
                [new Date(element.day), element.reservationCount],
              ]);
            });
            //Group by Year for Height of Chart
            of(...val).pipe(
              groupBy((p: any) => new Date(p.day).toLocaleDateString().split('.')[2]),
              mergeMap(group$ => {
                return group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
              }
              ),
              map(arr => {
                return ({ date: arr[0], reservations: arr.slice(1) })
              }),
              toArray()
            ).subscribe(value => {
              ///Draw Chart
              var chart = new google.visualization.Calendar(document.getElementById('calendar_basic'));
              var options = {
                title: "",
                tooltip: { isHtml: true },
                calendar: {
                  cellSize: this.scaleCell(5, 20),
                  daysOfWeek: 'MDMDFSS',
                },
                //Calc Height of Chart based on the Grouped Years
                height: 300 * value.length
              }
              chart.draw(dataTable, options);
              //Set Spinnter to invisible
              this.finishedLoadingCalendeData = true;
              this.isCalenderChartEmpty = false;
            })
          } else {
            document.getElementById('calendar_basic').style.display = 'none';
            this.finishedLoadingCalendeData = true;
            this.isCalenderChartEmpty = true;
          }
        });
      }
    });
  }

  changeEventForCalenderChart(e) {
    this.drawCalenderChart();
  }

  scaleCell(min, max) {
    var cellSize = window.innerWidth / 60;
    if (cellSize > max) return max;
    if (cellSize < min) return min;
    return cellSize;
  }

  filterEvents() {
    if (this.filterTestForm.invalid) {
      return
    }
    this.data_radar = [];
    combineLatest([
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent).pipe(
        catchError(err => of(err)),
      ),
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent_2).pipe(
        catchError(err => of(err)),
      ),
      this.eventService.getEventV1(this.filterTestForm.value.serachForEvent_3).pipe(
        catchError(err => of(err)),
      ),
    ]).pipe(
      map(([event_1, event_2, event_3]) => {
        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_1?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(

            {
              "group": event_1.title,
              "key": "Reservierungen",
              "value": event_1.totalActiveReservationsCount
            },
            {
              "group": event_1.title,
              "key": "eingelöst",
              "value": value.page.totalElements
            },
            {
              "group": event_1.title,
              "key": "Nicht eingelöst",
              "value": event_1.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })

        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_2?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(

            {
              "group": event_2.title,
              "key": "Reservierungen",
              "value": event_2.totalActiveReservationsCount
            },
            {
              "group": event_2.title,
              "key": "eingelöst",
              "value": value.page?.totalElements
            },
            {
              "group": event_2.title,
              "key": "Nicht eingelöst",
              "value": event_2.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })

        this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], event_3?.publicId).subscribe((value: PagedResources<any>) => {
          this.data_radar.push(

            {
              "group": event_3.title,
              "key": "Reservierungen",
              "value": event_3.totalActiveReservationsCount
            },
            {
              "group": event_3.title,
              "key": "eingelöst",
              "value": value.page?.totalElements
            },
            {
              "group": event_3.title,
              "key": "Nicht eingelöst",
              "value": event_3.totalActiveReservationsCount - value.page.totalElements
            }
          )
          this.data_radar = [...this.data_radar];
        })
      })
    ).subscribe(val => {
      this.finishedLoadingComparison = true;
    })

  }

  localeTranslateEventState(event) {
    switch (event) {
      case "EXTERNAL_EVENT":
        return "Partneraktion";
        case "RAFFLE":
          return "Gewinnspiel";
      case "SERVICE_PLUS":
        return "Exklusiv";
      case "MONETARY":
        return "Preisvorteil";
      default:
        return event;
    }
  }

  localeTranslateEventLimit(limit) {
    switch (limit) {
      case "WITHOUT_LIMIT":
        return "Ohne Einschränkung";
      case "ADULT":
        return "Erwachsene (>= 18 Jahre)";
      case "YOUTH":
        return "unter 18-jährige";
      case "CHILDREN":
        return "Kinder (6-12 Jahre)";
      case "CHILDREN2":
        return "Kinder 2 (8-14 Jahre)";
      case "WOMAN_ONLY":
        return "Frauen (>=18 Jahre)";
      case "MAN_ONLY":
        return "Männer (>= 18 Jahre)";
      case "TEENAGER":
        return "Jugendliche (13-17 Jahre)";
      case "BABYS":
        return "Kleinkinder (0-5 Jahre)";
      default:
        return limit;
    }
  }

  localeTranslateEventVoucherStrats(limit) {
    switch (limit) {
      case "GATES":
        return "Gates Gutscheincodes";
      case "EXTERNAL_SINGLE_KEY":
        return "Aktionspartnercodes (einer)";
      case "EXTERNAL_KEY_LIST":
        return "Aktionspartnercodes (mehrere)";
      default:
        return limit;
    }
  }
  showAllEvents() {
    if (this.allEvents == true) {
      this.eventFilter = ["ACTIVE", "HIDDEN", "EXPIRED", "ARCHIVED"];
    } else {
      this.eventFilter = ["ACTIVE", 'HIDDEN'];
    }

    this.finishedLoadingFlopsAndTops = true;
    this.finishedLoadingCalendeData = false;
    this.data_donut_1 = [];
    this.data_donut_2 = [];
    this.data_donut_3 = [];
    this.data_donut_1_flop = [];
    this.data_donut_2_flop = [];
    this.data_donut_3_flop = [];
    this.data_interest = [];
    this.data_donut_types = [];
    this.data_donut_eventLimits = [];
    this.data_donut_voucherStrats = [];
    this.data_savings = [];
    this.events = [];
    // this.treeData = [];
    this.data_word_cloud = [];
    this.data_reservations_line = [];

    this.top1Event = null;
    this.top2Event = null;
    this.top3Event = null;


    // this.filterEvents();
    // this.drawChart();

    this.hasSelectedPartner = true;
    let interestCount = [];
    let partnerCount = [];
    let eventTypes = [];


    

    combineLatest([
      this.eventService.searchForEvents(0, 1, ["ACTIVE", "HIDDEN", "EXPIRED", "ARCHIVED"], null, this.currentPartner.publicId, null),
      this.eventService.searchForEvents(0, 1, ["ACTIVE", "HIDDEN"], null, this.currentPartner.publicId, null)
    ]).subscribe(([allEventCount,eventCount]:[PagedResources<any>,PagedResources<any>])=>{
      this.eventCount = eventCount.page.totalElements;
      this.alleventCount = allEventCount.page.totalElements;
    })

    this.eventService.searchForEvents(0, 1, this.eventFilter, null, this.currentPartner.publicId, null).subscribe({
      next: (val: PagedResources<EventResource>) => {
        if(val.page.totalElements >=1){
      
          this.eventService.searchForEvents(0, val.page.totalElements, this.eventFilter, null, this.currentPartner.publicId, null).subscribe({
            next: (val: PagedResources<EventResource>) => {
              this.allActiveEvents = val.content;
              this.filteredOptions = val.content;
              this.filteredOptions_2 = val.content;
              this.filteredOptions_3 = val.content;
              val.content.forEach((element: EventResource, index) => {
                this.events.push({
                  value: element?.publicId, viewValue: element?.title, state: false
                })
                partnerCount.push(element.eventPartner);
                eventTypes.push(element);
              });
  
              const typesByCount = eventTypes.reduce((acc, value) => {
                // Group initialization
                if (!acc[value.eventDiscount]) {
                  acc[value.eventDiscount] = [];
                }
                // Grouping
                acc[value.eventDiscount].push(value);
                return acc;
              }, {});
  
              const voucherStrategiesByCount = eventTypes.reduce((acc, value) => {
                // Group initialization
                if (!acc[value.voucherKeyStrategy]) {
                  acc[value.voucherKeyStrategy] = [];
                }
                // Grouping
                acc[value.voucherKeyStrategy].push(value);
                return acc;
              }, {});
  
  
              const eventLimitByCount = eventTypes.reduce((acc, value) => {
                // Group initialization
                if (!acc[value.eventLimit]) {
                  acc[value.eventLimit] = [];
                }
                // Grouping
                acc[value.eventLimit].push(value);
                return acc;
              }, {});
  
              const savingInPercentByCount = eventTypes.reduce((acc, value) => {
                // Group initialization
                if (!acc[value.savingInPercent]) {
                  acc[value.savingInPercent] = [];
                }
                // Grouping
                acc[value.savingInPercent].push(value);
                return acc;
              }, {});
  
              Object.entries(savingInPercentByCount).forEach((element: any) => {
                this.data_savings.push({
                  "group": element[0] + " %",
                  "value": element[1].length
                })
              });
  
              let sum_savings = 0;
              this.data_savings.forEach(element => {
                sum_savings += element.value
              });
  
              Object.entries(typesByCount).forEach((element: any) => {
                this.data_donut_types.push({
                  "group": this.localeTranslateEventState(element[0]),
                  "value": element[1].length
                })
              });
  
              Object.entries(eventLimitByCount).forEach((element: any) => {
                this.data_donut_eventLimits.push({
                  "group": this.localeTranslateEventLimit(element[0]),
                  "value": element[1].length
                })
              });
  
              Object.entries(voucherStrategiesByCount).forEach((element: any) => {
                this.data_donut_voucherStrats.push({
                  "group": this.localeTranslateEventVoucherStrats(element[0]),
                  "value": element[1].length
                })
              });
  
              this.data_donut_types = [...this.data_donut_types];
              this.data_donut_eventLimits = [...this.data_donut_eventLimits];
              this.data_donut_voucherStrats = [...this.data_donut_voucherStrats];
              this.data_savings = [...this.data_savings];
              this.drawChart();
  
            },
            error: err => {
              console.log(err)
            }
          })
        }else{
          this.notEnoughEvents = true;
          this.finishedLoadingFlopsAndTops = true;
        }

      },
      error: err => {
        console.log(err)
      }

    })
  }
}
